import { SHELL } from "../shell/shell.const";

const HISTORIC = 'movimientos';
const HISTORIC_HOME = 'historial';
const HISTORIC_INVEST = 'mis-inversiones';
const HISTORIC_RESUME = 'resumen';
const HISTORIC_PAYMENTS_CALENDAR = 'calendario-de-pagos';

export const HISTORIC_ROUTES = {
  HISTORIC,
  HISTORIC_HOME,
  HISTORIC_INVEST,
  HISTORIC_RESUME,

  ROUTE_HISTORIC_HOME: `${SHELL}/${HISTORIC}/${HISTORIC_HOME}`,
  ROUTE_HISTORIC_INVEST: `${SHELL}/${HISTORIC}/${HISTORIC_INVEST}`,
  ROUTE_HISTORIC_RESUME: `${SHELL}/${HISTORIC}/${HISTORIC_RESUME}`,
  ROUTE_HISTORIC_PAYMENTS_CALENDAR: `${SHELL}/${HISTORIC}/${HISTORIC_PAYMENTS_CALENDAR}`,
}
